/**
 * Where the browser remembers which quote request it is working on.
 *
 * Tokens are stored per quote request, with a per-shop pointer at the most
 * recent one. The URL carries the request id (`?q=…`) so a customer can return
 * to the same submission from a bookmark rather than depending on this
 * browser's storage — but the id alone is not authorisation. If the token for
 * it isn't here (a different device, cleared storage), the customer re-enters
 * their contact details and the server hands the same request back.
 *
 * One module because the key format was previously written in two places and
 * they drifted, which silently broke resuming.
 */

const PREFIX = 'panelgear.intake';

export function tokenFor(quoteRequestId) {
  try {
    return localStorage.getItem(`${PREFIX}.q.${quoteRequestId}`) || null;
  } catch {
    return null;
  }
}

/** The most recent request started with this shop on this device. */
export function latestDraftFor(teamId) {
  try {
    const quoteRequestId = localStorage.getItem(`${PREFIX}.${teamId}`);
    if (!quoteRequestId) return null;

    const token = tokenFor(quoteRequestId);
    return token ? { quoteRequestId, token } : null;
  } catch {
    return null;
  }
}

export function rememberDraft(teamId, quoteRequestId, token) {
  try {
    localStorage.setItem(`${PREFIX}.q.${quoteRequestId}`, token);
    localStorage.setItem(`${PREFIX}.${teamId}`, quoteRequestId);
  } catch {
    /* private browsing — the id in the URL plus contact details still resume it */
  }
}

export function forgetDraft(teamId, quoteRequestId) {
  try {
    if (quoteRequestId) localStorage.removeItem(`${PREFIX}.q.${quoteRequestId}`);
    localStorage.removeItem(`${PREFIX}.${teamId}`);
  } catch {
    /* nothing to do */
  }
}
